<template>
  <SimpleCardDialog
    v-model:dialog="model"
    max-width="800"
    show-cancel
    :title="$t('User.Users')"
    @after-leave="reload()"
  >
    <UserForm
      ref="form"
      :current-data="currentData"
      :selected-groups="selectedGroups"
      @form-data="updateFormData"
    />

    <template #actions>
      <ActionButton
        save
        @click="submit()"
      />
    </template>
  </SimpleCardDialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CreateEditMixin from './CreateEditMixin'
  import UserForm from '../../components/forms/UserForm'

  export default {
    components: { UserForm },
    mixins: [CreateEditMixin],
    props: {
      // あらかじめグループを選択済みにする（新規作成時のみ有効）
      selectedGroups: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data: () => ({
      api: 'users'
    }),
    computed: {
      ...mapGetters(['login', 'ui'])
    },
    watch: {
      formData: {
        // 自分自身の言語もしくはタイムゾーンが更新された場合は更新後ブラウザをリロードする（その場で反映させるため）
        handler: function () {
          if (this.currentData) {
            if (this.currentData.id === this.login.profile.id) {
              this.browserReload = this.currentData.language !== this.formData.language || this.currentData.timezone !==
                this.formData.timezone
            }
          }
        },
        deep: true
      }
    }
  }
</script>
